import React from "react";
import { MyLocalStorage } from "../utils/storage";
import "./EndSessionButton.css";

const EndSessionButton: React.FC = () => {
  const handleEndSession = () => {
    const adminToken = MyLocalStorage.jwt_token_admin.get();

    if (adminToken) {
      MyLocalStorage.jwt_token.set(adminToken);
      MyLocalStorage.jwt_token_admin.remove();
      window.location.href = "/admin";
    }
  };

  return (
    <button className="end-session-button" onClick={handleEndSession}>
      End Session
    </button>
  );
};

export default EndSessionButton;
